
import GoodsListPage from '@/components/GoodsListPage'
import TitleBox from '@/components/CSS/TitleBox'

export default {
	components: {
		GoodsListPage,
		TitleBox
	},
	data() {
		return {
			showMask: true,
			pageInfo: {
				page: 1,
				pageSize: 20,
				total: 100
			},
			list: []
		}
	},
	created() {
		this.getPageUserConsultGoods()
	},
	methods: {
		join(e) {
			let _info = {
				action: {
					event: 'CONSULT_SERVICE_GAME',
					eventId: e.gameId
				}
			}
			this.$api.getRelatedClicks(_info).then(res => {})
			console.log(e)
			let info = {
				action: {
					gameId: e.gameId,
					goodsCatalogueId: e.goodsCatalogueId,
					goodsNo: e.goodsNo
				}
			}
			this.$api.getCustomerService(info).then(res => {
				if (!res.data) {
					this.$message({
						message: '暂无客服值班',
						type: 'error'
					})
					return
				}
				this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
				let goodsInformation = { goodsNo: e.goodsNo, title: '我的咨询' }
				this.$store.dispatch('ry/sendGoodsMsg', { targetId: res.data.id, content: goodsInformation })
				this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
				this.$store.commit('ry/SET_ORDER_FLOW', [])
			})
		},
		activeSellNav(index) {
			this.sellNavIndex = index
		},
		showMaskHandler(item) {
			item.showMask = !item.showMask
		},
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getPageUserConsultGoods()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getPageUserConsultGoods()
		},
		/**
		 * 商品所属客服链接
		 */
		getCustomerServiceConfig(item) {
			let p = {
				action: {
					gameId: item.gameId,
					goodsCatalogueId: item.goodsCatalogueId
				}
			}
			this.$store.dispatch('game/CustomerServiceConfig', p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				window.open(res.data.consultUrl)
			})
		},
		getPageUserConsultGoods() {
			let p = {
				action: {},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.pageUserConsultGoods(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				data.records.map(item => {
					item.showMask = false
				})
				this.list = data.records
				this.list.map(item => {
					return (item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg'))
				})
				this.pageInfo.total = Number(data.total)
			})
		},
		delOrderHandler(item) {
			this.$confirm('您确定要删除该咨询吗？', '提示', {
				confirmButtonText: '确定',
				type: 'error'
			})
				.then(() => {
					let p = {
						action: {
							id: item.id
						}
					}
					this.$api.deleteUserConsultGoods(p).then(res => {
						if (!res.success) {
							this.$message.error(res.info)
							return
						}
						this.getPageUserConsultGoods()
					})
				})
				.catch(() => {})
		},
		maskHandler(type, item) {
			if (type === 'viewDetails') {
				this.$router.push({
					name: 'goodsDetails',
					params: {
						goodsNo: item.goodsNo,
						goodsCatalogueId: item.goodsCatalogueId
					}
				})

				return
			}
			if (type === 'consult') {
				this.getCustomerServiceConfig(item)
			}
			if (type === 'delOrder') {
				this.delOrderHandler(item)
			}
		}
	}
}
